import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import { useToast } from '../../controller/ToastController';
import { AuthContext } from '../../navigation/AuthProvider';
import { fcmConciergeCountState, fcmSalesCountState } from '../../recoil/fcmMessage';
import { useConciergeState } from '../../recoil/concierge';
import { useInterphoneState } from '../../recoil/interphone';
import { SelectType } from '../../components/DropdownSelect';

type titleType = {
  title: string;
  content: string;
};
interface AccordionItem {
  title: string;
  link?: string;
  content?: { link: string; title: string }[];
}
interface sideBarType {
  currentStore: SelectType;
  currentTitle: titleType;
  accordionData: AccordionItem[];
  loadNewWindow: any;
  isUnReadNotice: boolean;
}

const Sidebar = ({
  currentStore,
  currentTitle,
  accordionData,
  loadNewWindow,
  isUnReadNotice,
}: sideBarType) => {
  const oAuthContext = useContext(AuthContext);
  const fcmSalesCount = useRecoilValue(fcmSalesCountState);
  const fcmConciergeCount = useRecoilValue(fcmConciergeCountState);

  const useConcierge = useRecoilValue<boolean>(useConciergeState);
  const useInterphone = useRecoilValue<boolean>(useInterphoneState);

  const [activeAccordion, setActiveAccordion] = useState<number | null>(null);
  const showToast = useToast();
  const doLogout = () => {
    oAuthContext.handleLogout();
  };

  const Header = () => {
    return (
      <div className="header">
        <div className="logoWrap">
          <img
            src={`${process.env.PUBLIC_URL}/img/knockLogo_gold.png`}
            alt="노크노크로고"
            width="100%"
            height="100%"
          />
          <p>HOTELIER</p>
        </div>
        <h2>{currentStore.name}</h2>
        <Link to={'/sales/monthly'}>
          <img
            src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`}
            width="30px"
            height="30px"
            alt="홈 바로가기"
            className="home"
          />
          <p>홈으로 가기</p>
        </Link>
      </div>
    );
  };

  return (
    <SidebarStyle>
      <div className="sidebarWrap">
        <Header />
        <div className="sidebarContentWrap">
          {accordionData.map((accordion: AccordionItem, index: number) => {
            return (
              <div className="wrapper" key={index}>
                <Link to={accordion.link!}>
                  <div
                    className={`title ${
                      currentTitle.title === accordion.title
                        ? accordion.content
                          ? 'select'
                          : 'active'
                        : ''
                    }`}
                    onClick={() => setActiveAccordion(activeAccordion === index ? null : index)}>
                    <div className="row">
                      <h3>
                        {accordion.title}
                        {accordion.title === '설정' && (
                          <img
                            src={`${process.env.PUBLIC_URL}/svg/ic_setting.svg`}
                            alt="설정 아이콘"
                          />
                        )}
                      </h3>
                      {((accordion.title === '판매 관리' && fcmSalesCount > 0) ||
                        (accordion.title === '객실 관리' && fcmConciergeCount > 0) ||
                        (accordion.title === '공지사항' && isUnReadNotice)) && (
                        <div className="countWrap">
                          <p>N</p>
                        </div>
                      )}
                    </div>

                    {accordion.content && activeAccordion === index ? (
                      <img
                        src={`${process.env.PUBLIC_URL}/svg/ic_arrow_down_grey_ce.svg`}
                        width="20px"
                        height="20px"
                        alt="더보기 화살표"
                      />
                    ) : (
                      activeAccordion !== index && (
                        <img
                          src={`${process.env.PUBLIC_URL}/svg/ic_arrow_right_white.svg`}
                          width="20px"
                          height="20px"
                          alt="더보기 화살표"
                        />
                      )
                    )}
                  </div>
                </Link>
                {activeAccordion === index && accordion.content && (
                  <div className="subTitle" style={{ height: `${accordion.content.length * 5}vh` }}>
                    {accordion.content &&
                      accordion.content.map((item: AccordionItem, itemIndex: number) => (
                        <>
                          {item.link === 'preparing' ? (
                            <div
                              onClick={() => {
                                showToast('사용하지 않는 기능입니다.', 'error', 1000);
                              }}>
                              <div
                                className={`titleLink ${
                                  currentTitle.content === item.title && 'active'
                                }`}>
                                <h3>• {item.title}</h3>
                              </div>
                            </div>
                          ) : (
                            <Link to={item.link || '/'} key={itemIndex}>
                              <div
                                className={`titleLink ${
                                  currentTitle.content === item.title && 'active'
                                }`}>
                                <h3>• {item.title}</h3>
                                {item.link &&
                                  item.link === '/manage/salemanager' &&
                                  fcmSalesCount > 0 && (
                                    <div className="countWrap">
                                      <p>{fcmSalesCount > 99 ? '99+' : fcmSalesCount}</p>
                                    </div>
                                  )}
                                {item.link &&
                                  item.link === '/room/request' &&
                                  fcmConciergeCount > 0 && (
                                    <div className="countWrap">
                                      <p>{fcmConciergeCount > 99 ? '99+' : fcmConciergeCount}</p>
                                    </div>
                                  )}
                              </div>
                            </Link>
                          )}
                        </>
                      ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className="bottomWrap">
          <Link to={'/manage/salemanager'}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_sidebar_pos_active.svg`} alt="포스아이콘" />
            <h3>POS 주문접수</h3>
          </Link>
          <Link to={'/room/checkout'}>
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_sidebar_checkout_active.svg`}
              alt="알림아이콘"
            />
            <h3>퇴실알림</h3>
          </Link>
          {useConcierge ? (
            <Link to={'/room/request'}>
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_sidebar_concierge_active.svg`}
                alt="컨시어지아이콘"
              />
              <h3>고객요청</h3>
            </Link>
          ) : undefined}
          {useInterphone ? (
            <Link to={'/room/interphone'}>
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_sidebar_interphone_active.svg`}
                alt="인터폰아이콘"
              />
              <h3>인터콤 발신</h3>
            </Link>
          ) : undefined}
          <Link to={'/room/device'}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_sidebar_device.svg`} alt="기기관리" />
            <h3>노크노크 기기 관리</h3>
          </Link>
          <Link to={'/notification/list'}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_sidebar_notice.svg`} alt="공지사항" />
            <h3>공지사항</h3>
          </Link>
          <button onClick={doLogout}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_logout.svg`} alt="로그아웃" />
            <h3>로그아웃</h3>
          </button>
          <button className="functionButton" onClick={loadNewWindow}>
            <h3>직영매장 바로가기</h3>
          </button>
        </div>
      </div>
    </SidebarStyle>
  );
};

export default Sidebar;

export const SidebarStyle = styled.div`
  .sidebarWrap {
    height: 100%;
    min-height: 100dvh;
    max-height: 100%;
    padding: 24px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #2b2b2b;
    overflow-y: auto;
  }

  .header {
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: center;
    padding-bottom: 16px;
    border-bottom: 2px solid #383838;

    h2 {
      font-size: 16px;
      font-weight: 400;
      color: #f6e7b4;
    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      img {
        width: 24px;
        height: 24px;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: #fff;
      }
    }
  }
  .logoWrap {
    padding: 6px 0;
    margin: 0 16px;
    border: 1px solid #f6e7b4;
    border-radius: 14px;
    background: #2b2b2b;
    img {
      height: 16px;
      object-fit: contain;
    }
    p {
      font-size: 14px;
      line-height: 20px;
      font-weight: 200;
      color: #f6e7b4;
    }
  }

  /* sidebarContentWrap */
  .sidebarContentWrap {
    padding: 0 8px;
    flex: 1;
  }

  .sidebarContentWrap .title {
    margin: 11px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px 10px 24px;

    h3 {
      display: flex;
      align-items: center;
      gap: 4px;
      color: #cecece;
      font-weight: 500;
    }
  }
  .title.select {
    margin: 11px 0;
    background: #333a38;
    border-radius: 5px;
  }
  .title.active {
    background: #4dd2ae;
    border-radius: 5px;
  }
  .title.select,
  .title.active h3 {
    color: #fff;
    font-weight: 400;
  }

  .subTitle {
    min-height: 100%;
    height: inherit;
    animation: expandDown 0.3s ease-out;
  }

  .countWrap {
    margin: -10px 0 0 8px;
    width: 20px;
    height: 20px;
    background: #ff6060;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      font-size: 12px;
      line-height: 12px;
      font-weight: 600;
      color: #ffffff;
    }
  }

  .subTitle .titleLink {
    display: flex;
    width: 100%;
    padding: 8px 29px;

    h3 {
      font-size: 16px;
      color: #cecece;
      font-weight: 400;
    }

    .countWrap {
      margin: -4px 0 0 6px;
    }
  }
  .titleLink.active {
    background: #4dd2ae;
    border-radius: 5px;
    h3 {
      color: #ffffff;
    }
  }

  .sidebarTabWrap {
    min-height: 90vh;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .bottomWrap {
    border-top: 2px solid #383838;
    width: 100%;
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 28px;

    h3 {
      color: #cecece;
      font-weight: 500;
    }
    button,
    a {
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 0;
      cursor: pointer;
    }

    img {
      width: 24px;
      height: 24px;
    }
  }

  .functionButton {
    margin-top: 24px;
    border-radius: 5px;
    padding: 6px 0 !important;
    border: 1px solid #4dd2ae;
    justify-content: center;

    h3 {
      font-size: 16px;
      color: #4dd2ae;
      font-weight: 600;
    }
  }

  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
